import React, {Component} from 'react';
import axios from 'axios';
import firebase from 'utils/firebase';
import Pick from 'components/Cards/Pick';
import {getPickTimestamp} from 'components/Cards/Pick/helpers';
import {Loader} from 'components/Loader';

import './settledFavorites.scss';

class SettledFavorites extends Component {
  state = {
    loading: true,
  };

  async componentDidMount() {
    try {
      const userToken = await firebase.auth().currentUser.getIdToken();
      const settledFavorites = await axios.get('/v3/favorites?skip=0&limit=100&status=resolved', {
        headers: {token: userToken},
      });
      const sortedByEventTime = settledFavorites.data.sort(
        (a, b) => getPickTimestamp(b.event) - getPickTimestamp(a.event),
      );
      this.setState({
        settledFavorites: sortedByEventTime,
        loading: false,
      });
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    const {loading, settledFavorites} = this.state;
    if (loading) {
      return <Loader />;
    }
    return (
      <div className="settled-favorites">
        {settledFavorites.length ? (
          settledFavorites.map(favorite => <Pick key={favorite.id} pick={favorite} />)
        ) : (
          <p className="message no-settled">You don&apos;t have settled picks.</p>
        )}
      </div>
    );
  }
}

export default SettledFavorites;
